/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// gsap.registerPlugin(ScrollTrigger,ScrollSmoother);
import imagesLoaded from 'imagesloaded';
import { slider } from './modules/slider';

// Cursor stuff
// import Cursor from "./modules/cursor";
// import Magnetic from "./modules/magnetic";


imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {
  // Load stuff after all the images in the body load
  var sliderExists = document.querySelector('.slider');
  if (sliderExists) {
    slider();
  }
});

// Animate On Scroll
// import { animateOnScroll } from './modules/animateOnScroll.js';
// animateOnScroll();

// Don't load on mobile
function is_touch_enabled() {
  return ( 'ontouchstart' in window ) ||
         ( navigator.maxTouchPoints > 0 ) ||
         ( navigator.msMaxTouchPoints > 0 );
}

// Get URL Params
// import './modules/getUrlParams';


// Mobile vs. Desktop controls
if( ! is_touch_enabled() ) {



} else {
  $('body').addClass('touch');
}

// Load 'em
// import { heroSplitText } from './modules/heroSplitText';
// heroSplitText();

import { mobileNav } from './modules/mobileNav';
mobileNav();

// import { siteCookieControls } from './modules/cookies';
// siteCookieControls();

// import { popup } from './modules/popup';
// popup();

var formExists = document.querySelector('.gform_body');
import { contactForm } from './modules/contactForm';
if (formExists) {
  contactForm();
}

var togglesExist = document.querySelector('.accordion__toggle');
import { toggles } from './modules/toggle';
if (togglesExist) {
  toggles();
}

// import { anchorLinks } from './modules/anchors';
// anchorLinks();

// Refire stuff on window resize
var timeout = false, // holder for timeout id
    delay   = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    ScrollTrigger.refresh();
  }, delay);
});

